import { Routes, RouterModule } from "@angular/router";
import { HallSweepComponent } from "./components/hall-sweep.component";
import { ConsequenceMaintenanceComponent } from "./consequence-maintenance/consequence-maintenance.component";
import { HallSweepActivationComponent } from "./hall-sweep-activation/hall-sweep-activation.component";
import { HallSweepSettingsComponent } from "./hall-sweep-settings/hall-sweep-settings.component";
import { AuthguardService } from "../master/services";

export const HallSweepRoutes: Routes = [
	{ path: "", redirectTo: "/hallsweep/activation", pathMatch: "full" },
	{
		path: "activation",
		data: { title: "CAASS Pass Activation" },
		component: HallSweepActivationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "consequence",
		data: { title: "Consequence Maintenance" },
		component: ConsequenceMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "settings",
		data: { title: "CAASS Pass Settings" },
		component: HallSweepSettingsComponent,
		canActivate: [AuthguardService],
	},
];
